<template>
  <v-dialog v-model="dialog" width="620px">
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-btn class="ml-6" depressed color="primary">
          <v-icon left>add</v-icon>
          Thêm {{ $route.meta.title }}
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title class="text-uppercase">THÊM {{ $route.meta.title }}</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider />
      <CreateHeadForm ref="form" />
      <v-divider />
      <v-card-actions class="mt-5">
        <v-btn depressed outlined color="grey darken-1" class="px-6 ml-4 mt-n4 mb-2 white--text" @click="cancel">
          Hủy
        </v-btn>
        <v-spacer />
        <v-btn depressed class="px-6 mr-4 mt-n4 mb-2 white--text" :loading="loading" color="primary" @click="save">
          Lưu
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import CreateHeadForm from './CreateHeadForm.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    CreateHeadForm
  },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  methods: {
    ...mapActions('salaryHead', ['createHead']),
    cancel() {
      this.reset()
      this.dialog = false
    },
    reset() {
      this.$refs.form.reset()
    },
    async save() {
      this.loading = true
      const data = this.$refs.form.getData()
      if (data) {
        await this.createHead(data)
        this.reset()
        this.$emit('onAddHeadSuccess')
        this.dialog = false
      }
      this.loading = false
    }
  }
}
</script>
